<template>
  <div :class="['rb-filter-group', { 'rb-images': images }]">
    <div class="rb-fg-title">
      <h3>{{ title }}</h3>
      <a
        href="#"
        v-if="helpId !== ''"
        @click.prevent="notifyPopup($event, helpId)"
        :id="`btn-learn-more-${type}`"
        >Learn More</a
      >
    </div>
    <div
      :class="['rb-fg-description', { 'rb-warn': descriptionWarn }]"
      v-if="description !== ''"
    >
      <p>{{ description }}</p>
    </div>
    <div class="rb-fg-options">
      <div
        class="rb-btn-filter-wrap"
        v-for="(filter, indexFilter) in filters"
        :key="`filter-color-${indexFilter}`"
      >
        <button
          :class="[
            'rb-btn-filter',
            {
              'rb-active': appliedFiltersOfType.find(
                (appliedFilter) => appliedFilter.id === filter.id
              ),
            },
          ]"
          :id="`btn-filter-${type}-${slugify(filter.title)}`"
          @click.prevent="applyFilter($event, filter)"
        >
          <template v-if="filter.image">
            <img
              :src="filter.image"
              :alt="filter.title"
              class="lazyload"
              loading="lazy"
            />
          </template>
          <template v-else>{{ filter.title }}</template>
        </button>
        <span v-if="filter.image">{{ filter.title }}</span>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Displays a set of filters grouped by criteria
 *
 * @props
 * title: String
 * description: String
 * descriptionWarn: Boolean
 * helpId: String
 * filters: Array
 * appliedFilters: Array
 * images: Boolean
 * type: String
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @emits
 * rb-update-filters
 * rb-open-popup
 */
import { slugify } from "@/lib";
import TrackMixin from "@/mixins/TrackMixin";
import CommMixin from "@/mixins/CommMixin";
export default {
  mixins: [CommMixin, TrackMixin],
  props: {
    title: {
      type: String,
      default: "Filters",
    },
    description: {
      type: String,
      default: "",
    },
    descriptionWarn: {
      type: Boolean,
      default: false,
    },
    helpId: {
      type: String,
      default: "",
    },
    filters: {
      type: Array,
    },
    appliedFilters: {
      type: Array,
      default: () => [],
    },
    images: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  computed: {
    appliedFiltersOfType: function () {
      return this.appliedFilters.filter((filter) => filter.type === this.type);
    },
  },
  methods: {
    applyFilter: function (event, filter) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-update-filters", filter);
    },
    notifyPopup: function (event, helpId) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-open-popup", { id: helpId });
    },
    slugify: function (str) {
      return slugify(str);
    },
  },
};
</script>
